import { useMemo } from "react";
import scopedStorage from "@/utils/scopedStorage";
import { useUserContext } from "@/contexts";

/**
 * Hook to read/write per-user localStorage.
 * No-ops when unauthenticated.
 */
export function useScopedStorage() {
  const { userSub } = useUserContext();

  return useMemo(
    () => ({
      get: (key) => scopedStorage.get(userSub, key),
      set: (key, value) => scopedStorage.set(userSub, key, value),
      remove: (key) => scopedStorage.remove(userSub, key),
      userSub,
    }),
    [userSub]
  );
}

export default useScopedStorage;
